var React = require('react');

function Change (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 8H17M17 8L13 4M17 8L13 12M20 16H7M7 16L11 12M7 16L11 20","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Change.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","fill":"none"};

module.exports = Change;

Change.default = Change;
